import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {  Routes, Route,useLocation } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import LoginPage from "./pages/LoginPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import AdminPanel from "./pages/admin/AdminPanel";
import ProductAdd from "./pages/admin/ProductAdd";
import CategoryAdd from "./pages/admin/CategoryAdd";
import CategoryEdit from "./pages/admin/CategoryEdit";
import ProductEdit from "./pages/admin/ProductEdit";
import CouponAdd from "./pages/admin/CouponAdd";
import CouponEdit from "./pages/admin/CouponEdit";
import ProductDiscountAdd from "./pages/admin/ProductDiscountAdd";
import ProductDiscountEdit from "./pages/admin/ProductDiscountEdit";
import Users from "./pages/admin/Users";
import Orders from "./pages/admin/Orders";
import Reports from "./pages/admin/Reports";
import ShippingFee from "./pages/admin/ShippingFee";
import Seasons from "./pages/admin/Seasons";
import ResetPasswordPage from "./pages/ResetPasswordPage";
// Components
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';

// Pages
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import SeasonProductsPage from './pages/SeasonProductsPage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import ContactPage from './pages/ContactPage';
import RegisterPage from './pages/RegisterPage';
import AccountPage from './pages/AccountPage';
import KargoSureci from './pages/KargoSureci';
import KvkkPage from './pages/KvkkPage';
import UyelikSozlesmesi from './pages/UyelikSozlesmesi';
import MssPage from './pages/MssPage';

// Context
import { CartProvider } from './Context/CartContext';

const App = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        {isLoading ? (
          <div className="flex items-center justify-center h-screen bg-secondary-light">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.5 }}
              className="text-3xl font-semibold text-primary"
            >
              Loading...
            </motion.div>
          </div>
        ) : (

            <div className="flex flex-col min-h-screen">
            {!isAdminRoute && <Header />}
              <main className="flex-grow">
                <AnimatePresence mode="wait">
                  <Routes>
                    {/* Main App Routes */}
                    <Route path="/" element={<HomePage />} />
                    <Route path="/products/:categoryId/:subcategoryId" element={<ProductsPage />} />
                    <Route path="/products/detail/:id" element={<ProductDetailPage />} />
                    <Route path="/products/season" element={<SeasonProductsPage />} />
                    <Route path="/cart" element={<CartPage />} />
                    <Route path="/checkout" element={<CheckoutPage />} />
                    <Route path="/contact" element={<ContactPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/account" element={<AccountPage />} />
                    <Route path="/kargo-sureci" element={<KargoSureci />} />
                    <Route path="/kvkk" element={<KvkkPage />} />
                    <Route path="/uyelik-sozlesmesi" element={<UyelikSozlesmesi />} />
                    <Route path="/mesafeli-satis-sozlesmesi" element={<MssPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    {/* Admin Panel Routes */}
                    <Route path="/admin" element={<AdminPanel />} />
                    <Route path="/admin/category/add" element={<CategoryAdd />} />
                    <Route path="/admin/category/edit" element={<CategoryEdit />} />
                    <Route path="/admin/product/add" element={<ProductAdd />} />
                    <Route path="/admin/product/edit" element={<ProductEdit />} />
                    <Route path="/admin/coupon/add" element={<CouponAdd />} />
                    <Route path="/admin/coupon/edit" element={<CouponEdit />} />
                    <Route path="/admin/discount/add" element={<ProductDiscountAdd />} />
                    <Route path="/admin/discount/edit" element={<ProductDiscountEdit />} />
                    <Route path="/admin/users" element={<Users />} />
                    <Route path="/admin/orders" element={<Orders />} />
                    <Route path="/admin/reports" element={<Reports />} />
                    <Route path="/admin/shipping" element={<ShippingFee />} />
                    <Route path="/admin/seasons" element={<Seasons />} />
                  </Routes>
                </AnimatePresence>
              </main>
              {!isAdminRoute && <Footer />}
            </div>

        )}
      </CartProvider>
    </AuthProvider>
  );
}
export default App;
